// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerStyle {\n    font-weight: bold;\n    color: black;\n}[dir] .headerStyle {\n    background-color: #f3f2f7;\n}\n", "",{"version":3,"sources":["webpack://src/assets/css/extra.css"],"names":[],"mappings":"AAAA;IAEI,iBAAiB;IACjB,YAAY;AAChB,CAJA;IACI,yBAAyB;AAG7B","sourcesContent":[".headerStyle {\n    background-color: #f3f2f7;\n    font-weight: bold;\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
